import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { animatePage } from "../../animation/animationPage";
import NavContext from "../../context/NavContext";
import { CabineProvider } from "../../context/CabineContext";
import SupportRequestForm from "../../components/SupportRequest/SupportRequestForm";
import styles from "../CalibrationRequestPage/CalibrationRequestPage.module.scss";

const SupportRequestPage = () => {
  const navigate = useNavigate();
  const { ownerProfile, ownerId } = useContext(NavContext);

  const handleClose = () => {
    navigate("/private/dashboard");
  };

  return (
    <motion.div
      className={styles.page}
      variants={animatePage}
      exit="exit"
      initial="hidden"
      animate="visible"
    >
      <CabineProvider>
        <SupportRequestForm
          ownerProfile={ownerProfile}
          ownerId={ownerId}
          onClose={handleClose}
        />
      </CabineProvider>
    </motion.div>
  );
};

export default SupportRequestPage;
